<p-card
  *ngIf="planning && withCard"
  [header]="headerName"
  [styleClass]="styleClass">
  <ng-template [ngTemplateOutlet]="form"></ng-template>
</p-card>

<ng-container *ngIf="planning && !withCard">
  <ng-template [ngTemplateOutlet]="form"></ng-template>
</ng-container>

<ng-template #form>
  <div class="formgrid grid">
    <div
      *ngIf="isShowPeriodicityList"
      class="field sm:col-6 col-12 frm-filters-ui-v2">
      <label
        class="font-medium"
        [class.required-field]="isRequiredField"
        >Повторение</label
      >
      <crm-periodicity-single-select
        [(periodicity)]="planning.periodicity"
        [class]="errors?.periodicity ? 'ng-invalid ng-dirty' : ''"
        styleClass="w-full {{ errors?.periodicity ? 'ng-invalid ng-dirty' : '' }}"
        [appendTo]="appendTo"></crm-periodicity-single-select>
      <small
        *ngIf="errors?.periodicity"
        class="p-error">
        {{ errors.periodicity | join }}
      </small>
    </div>

    <div
      class="field col-12 frm-filters-ui-v2"
      [ngClass]="isShowPeriodicityList ? 'sm:col-6' : 'col-12'">
      <label class="font-medium">Время</label>
      <div class="flex gap-3 align-items-start">
        <div class="flex-grow-1">
          <crm-datepicker
            [(value)]="timeInternal"
            (valueChange)="changeTime()"
            [inputStyleClass]="errors?.time ? 'ng-invalid ng-dirty' : ''"
            [timeOnly]="true"
            styleClass="w-full"
            [appendTo]="appendTo"></crm-datepicker>
          <small
            *ngIf="errors?.time"
            class="p-error">
            {{ errors.time | join }}
          </small>
        </div>

        <crm-button
          *ngIf="isShowClearButton"
          type="button"
          icon="pi pi-times"
          styleClass="p-button-rounded p-button-danger p-button-text -ml-2"
          (onClick)="onClearPlanning.emit()"></crm-button>
      </div>
    </div>

    <div
      *ngIf="planning?.periodicity === TemplateEntityPeriodicityEnum.ONCE || !isShowPeriodicityList"
      class="field lg:col-6 col-12">
      <label
        class="font-medium"
        [class.required-field]="isRequiredField"
        >Дата создания</label
      >
      <crm-datepicker
        [(value)]="planning.runDate"
        [inputStyleClass]="errors?.runDate ? 'ng-invalid ng-dirty' : ''"
        styleClass="w-full"
        [appendTo]="appendTo"
        (valueChange)="runDateChange.emit($event)"></crm-datepicker>
      <small
        *ngIf="errors?.runDate"
        class="p-error">
        {{ errors.runDate | join }}
      </small>
    </div>

    <div
      *ngIf="planning?.periodicity === TemplateEntityPeriodicityEnum.WEEKLY"
      class="field lg:col-6 col-12">
      <label
        class="font-medium"
        [class.required-field]="isRequiredField"
        >День недели</label
      >
      <crm-days-of-week-single-select
        [(value)]="planning.dayOfWeek"
        [isError]="!!errors?.dayOfWeek"
        [appendTo]="appendTo"></crm-days-of-week-single-select>
      <small
        *ngIf="errors?.dayOfWeek"
        class="p-error">
        {{ errors.dayOfWeek | join }}
      </small>
    </div>

    <div
      *ngIf="planning?.periodicity === TemplateEntityPeriodicityEnum.ON_WORK_DAYS"
      class="field lg:col-6 col-12">
      <label
        class="font-medium"
        [class.required-field]="isRequiredField"
        >День недели</label
      >
      <crm-days-of-week-single-select
        [options]="workDayOptions"
        [(value)]="planning.dayOfWeek"
        [isError]="!!errors?.dayOfWeek"
        [appendTo]="appendTo"></crm-days-of-week-single-select>
      <small
        *ngIf="errors?.dayOfWeek"
        class="p-error">
        {{ errors.dayOfWeek | join }}
      </small>
    </div>

    <div
      *ngIf="planning?.periodicity === TemplateEntityPeriodicityEnum.QUARTERLY"
      class="field lg:col-6 col-12">
      <label
        class="font-medium"
        [class.required-field]="isRequiredField"
        >Месяц в квартале</label
      >
      <crm-month-in-quarter-single-select
        [(value)]="planning.monthOfQuarter"
        [isError]="!!errors?.monthOfQuarter"
        [appendTo]="appendTo"></crm-month-in-quarter-single-select>
      <small
        *ngIf="errors?.monthOfQuarter"
        class="p-error">
        {{ errors.monthOfQuarter | join }}
      </small>
    </div>

    <div
      *ngIf="planning?.periodicity === TemplateEntityPeriodicityEnum.ANNUALLY"
      class="field lg:col-6 col-12">
      <label
        class="font-medium"
        [class.required-field]="isRequiredField"
        >Месяц</label
      >
      <crm-month-of-year-single-select
        [(value)]="planning.monthOfYear"
        [isError]="!!errors?.monthOfYear"
        [appendTo]="appendTo"></crm-month-of-year-single-select>
      <small
        *ngIf="errors?.monthOfYear"
        class="p-error">
        {{ errors.monthOfYear | join }}
      </small>
    </div>

    <div
      *ngIf="
        planning?.periodicity === TemplateEntityPeriodicityEnum.MONTHLY ||
        planning?.periodicity === TemplateEntityPeriodicityEnum.QUARTERLY ||
        planning?.periodicity === TemplateEntityPeriodicityEnum.ANNUALLY
      "
      class="field lg:col-6 col-12 frm-filters-ui-v2">
      <label
        class="font-medium"
        [class.required-field]="isRequiredField"
        >Число месяца</label
      >
      <p-inputNumber
        [(ngModel)]="planning.dayOfMonth"
        [max]="31"
        [min]="1"
        [ngClass]="{ 'ng-invalid ng-dirty': errors?.dayOfMonth }"
        styleClass="w-full"
        class="w-full"></p-inputNumber>
      <small
        *ngIf="errors?.dayOfMonth"
        class="p-error">
        {{ errors.dayOfMonth | join }}
      </small>
    </div>
  </div>
</ng-template>
